"use strict";

exports.__esModule = true;
exports.DsButtonCollapse = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DsButtonCollapse = exports.DsButtonCollapse = function DsButtonCollapse(_ref) {
  var onClick = _ref.onClick,
    isCollapsed = _ref.isCollapsed,
    dataCollapsed = _ref.dataCollapsed,
    children = _ref.children,
    _ref$additionalClassN = _ref.additionalClassNames,
    additionalClassNames = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    className: "btn btn-flat-primary text-xxlarge justify-content-start ps-0 " + additionalClassNames,
    onClick: onClick,
    "data-toggle": 'collapse',
    "data-target": "#" + dataCollapsed,
    "aria-expanded": "false",
    "aria-controls": dataCollapsed,
    children: [isCollapsed ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      className: "icon icon-sm me-2 text-secondary",
      children: "keyboard_arrow_down"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
      className: "icon icon-sm me-2 text-secondary",
      children: "keyboard_arrow_right"
    }), children]
  });
};